<div class="col-group">
  @for (rate of rates(); track rate) {
    <div>
      <h6>{{ rate.getName() }}</h6>
      <ul>
        @for (
          surchargeType of surchargeTypeList[rate.getId()];
          track surchargeType
        ) {
          <li pTooltip="{{ surchargeType.getInternalDescription() }}">
            @if (!surchargeType.getActive()) {
              <p-checkbox
                [ngModel]="false"
                [binary]="true"
                [disabled]="true"
                [inputId]="rate.getId() + '-' + surchargeType.getId()"
              />
              <label
                class="disabled"
                [for]="rate.getId() + '-' + surchargeType.getId()"
                >{{ surchargeType.getNameForLocale(locale) }}</label
              >
            }
            @if (
              surchargeType.getActive() && surchargeType.getWarningMessage()
            ) {
              <button
                type="button"
                class="surcharge-warning"
                aria-label="Surcharge restrictions"
                [id]="rate.getId() + '-' + surchargeType.getId()"
                (click)="openWarning($event, surchargeType, warningPopover)"
              >
                <!-- PrimeIcons' exclamation-triangle, cropped to its own bounds: the font glyph sits by font metrics, which Firefox and Chrome place differently. -->
                <svg
                  aria-hidden="true"
                  viewBox="0 -900.705 1024 905.407"
                  fill="currentColor"
                >
                  <path
                    transform="scale(1 -1)"
                    d="M980.247-4.701h-936.496c-16.088 0.051-30.159 8.633-37.933 21.458l-0.111 0.198c-3.59 6.323-5.705 13.888-5.705 21.949s2.115 15.627 5.823 22.173l-0.117-0.224 468.247 819.433c8.296 12.379 22.232 20.419 38.044 20.419s29.748-8.039 37.942-20.254l0.104-0.165 468.247-819.433c3.59-6.323 5.705-13.888 5.705-21.949s-2.115-15.627-5.823-22.173l0.117 0.224c-7.885-13.022-21.958-21.606-38.038-21.657h-0.007zM119.257 83.095h785.486l-392.743 687.154zM512 317.22c-24.113 0.325-43.573 19.786-43.898 43.866v204.89c0 24.244 19.654 43.898 43.898 43.898s43.898-19.654 43.898-43.898v0-204.858c-0.325-24.113-19.786-43.573-43.866-43.898h-0.032zM512 141.627c-24.113 0.325-43.573 19.786-43.898 43.866v29.297c0 24.244 19.654 43.898 43.898 43.898s43.898-19.654 43.898-43.898v0-29.265c-0.325-24.113-19.786-43.573-43.866-43.898h-0.032z"
                  />
                </svg>
              </button>
              <label
                class="disabled"
                [for]="rate.getId() + '-' + surchargeType.getId()"
                >{{ surchargeType.getNameForLocale(locale) }}</label
              >
            }
            @if (
              surchargeType.getActive() &&
              !surchargeType.getWarningMessage() &&
              !surchargeType.getMandatory()
            ) {
              <p-checkbox
                [ngModel]="isSelected(rate, surchargeType)"
                (onChange)="toggleSelection(rate, surchargeType)"
                [binary]="true"
                [disabled]="loading || surchargeType.getDeleted()"
                [inputId]="rate.getId() + '-' + surchargeType.getId()"
              />
              <label [for]="rate.getId() + '-' + surchargeType.getId()">{{
                surchargeType.getNameForLocale(locale)
              }}</label>
            }
            @if (
              surchargeType.getActive() &&
              !surchargeType.getWarningMessage() &&
              surchargeType.getMandatory()
            ) {
              <p-checkbox
                [ngModel]="true"
                [binary]="true"
                [disabled]="true"
                [inputId]="rate.getId() + '-' + surchargeType.getId()"
              />
              <label
                class="disabled"
                [for]="rate.getId() + '-' + surchargeType.getId()"
                >{{ surchargeType.getNameForLocale(locale) }}</label
              >
            }
          </li>
        }
      </ul>
    </div>
  }
</div>
<p-popover appPopoverArrow appendTo="body" #warningPopover [dismissable]="true">
  <div [innerHTML]="warningMessage | safeHtml"></div>
</p-popover>
